import TRANSLATE_EN from "./en/translations.json";
import TRANSLATE_DE from "./de/translations.json";

export const translations = {
  en: { translation: TRANSLATE_EN },
  de: { translation: TRANSLATE_DE },
};
